module.exports = __webpack_public_path__ + "static/media/eyeOpen.6b17c70a.svg";